import { AfterViewInit, Component, ElementRef, OnInit, ViewEncapsulation, output, input, inject } from '@angular/core';

import { AvailableIcons, ApIconComponent, ApActionIconComponent } from '@ap/icon';

import { NavigationItem, NavigationType } from '../../header.model';
import { ApVerticalNavigationItemComponent } from '../vertical-navigation-item/vertical-navigation-item.component';

@Component({
    selector: 'ap-vertical-submenu',
    templateUrl: './vertical-submenu.component.html',
    styleUrls: ['./vertical-submenu.component.scss'],
    encapsulation: ViewEncapsulation.Emulated,
    imports: [ApIconComponent, ApActionIconComponent, ApVerticalNavigationItemComponent]
})
export class ApVerticalSubmenuComponent implements AfterViewInit, OnInit {
    private hostElement = inject(ElementRef);

    /**
     * The navigation items
     */
    public readonly navigationItem = input<NavigationItem>();

    /**
     * emits the NavigationItem that is clicked
     */
    public readonly navigationClicked = output<NavigationItem>();

    /**
     * emits if back is clicked
     */
    public readonly backClicked = output<void>();

    public navigationType = NavigationType;

    // Temporary fix. Remove A19
    ngOnInit() {
        const navigationItem = this.navigationItem();
        if (navigationItem.iconName !== null) {
            navigationItem.iconName = navigationItem.label as AvailableIcons;
        }
    }

    ngAfterViewInit() {
        this.hostElement.nativeElement.querySelector('a, button, ap-icon').focus();
    }
}
